import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
    static component = "profile"

    connect() {
        super.connect()

        const profilePictureUrl = this.element.dataset.profilePictureUrl
        this.profilePath = this.element.dataset.profilePath || "/profile/details"
        const hidesSharedBackground = this.element.dataset.hidesSharedBackground === "true"

        if (profilePictureUrl) {
            // Enable the profile button in the native app
            this.send("connect", { profilePictureUrl, hidesSharedBackground }, (message) => {
                if (message.data.profile !== undefined) {
                    this.handleProfileRequest()
                }
            })
        }
    }

    handleProfileRequest() {
        window.Turbo.visit(this.profilePath)
    }
}
